<template>
    <textarea
        :rows="rows"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:blur="$emit('filled-out', $event.target.value)"
    ></textarea>
</template>

<script>
  export default {
    props: {
      field: {},
      value: '',
    },
    computed: {
      rows() {
        return this.field.rows || 5;
      },
    },
  };
</script>
